export enum ConditionRenderType {
  None = 'None',
  Show = 'Show',
  Hide = 'Hide',
  Disable = 'Disable',
  Enable = 'Enable',
}
